var _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropMelo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agrismart-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m24 12c0 6.6164-5.3836 12-12 12s-12-5.3836-12-12c0-6.6164 5.3836-12 12-12s12 5.3836 12 12z",
    style: {
      clipRule: "evenodd",
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.041096
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.041096 0 0 .041096 -212.51 -546.62)",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m5387 13503c-38 6-57 39-63 78-7 43 4 83 21 116 13 26 41 61 75 67 30 5 30-16 57-3 19 9 41 0 54-9 46-32 89-122 58-202-6-16-17-29-32-39-17-11-38-10-58-3-19 7-32 16-56 8-18-6-35-17-57-13z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m5470 13494c37-4 62-34 65-72-37 4-62 33-65 72z",
    style: {
      fill: "#fefefe"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "m8.7945 8.589c-1.6027 0.28767-2.1781 1.9726-2.3014 3.411 0 0.20548-0.08219 0.69863 0 0.90411 0.08219 0.24658 0.45206 0.32877 0.61644 0.12329 0.24658-0.28767-0.08219-3.4932 2.0137-3.6986 0.65753-0.08219 0.61644-0.90411-0.28767-0.73973z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.041096
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropMelo);
export default __webpack_public_path__ + "static/media/crop-melo.e4e124df6c74c60df85715084b5927e9.svg";
export { ForwardRef as ReactComponent };